module.exports = __webpack_public_path__ + "img/0.7429eb41.png";